import {
	SET_FACILITIES,
	SET_FACILITY,
	CLEAR_FACILITIES,
	CLEAR_FACILITY,
	ADD_FACILITY,
	UPDATE_FACILITY,
	REMOVE_FACILITY,
} from './actionTypes';

export const facility = (state = {}, action) => {
	switch (action.type) {
		case SET_FACILITY:
			return action.payload;
		case UPDATE_FACILITY:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_FACILITY:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_FACILITIES:
			return action.payload;
		case ADD_FACILITY:
			return [...state, action.payload];
		case UPDATE_FACILITY:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_FACILITY:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_FACILITIES:
			return [];
		default:
			return state;
	}
};
